module.exports = __webpack_public_path__ + "static/media/download.2dd404f5.svg";